import { render, staticRenderFns } from "./ImagesBlock.vue?vue&type=template&id=1fdfedfd&scoped=true&"
import script from "./ImagesBlock.vue?vue&type=script&lang=js&"
export * from "./ImagesBlock.vue?vue&type=script&lang=js&"
import style0 from "./ImagesBlock.vue?vue&type=style&index=0&id=1fdfedfd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fdfedfd",
  null
  
)

export default component.exports